import { useEffect, useState } from "react";
import LineGraph from "components/LineGraph/LineGraph";
import { getAthleteAverages } from "repositories/patientApi";
import moment from "moment";

const COLORS = [
  "hsl(0, 70%, 50%)",
  "hsl(131, 92.82868525896416%, 49.2156862745098%)",
  "hsl(240, 70%, 50%)",
  "hsl(180, 70%, 50%)",
  "hsl(120, 70%, 50%)",
];
interface Athlete {
  _id: string;
  firstName: string;
  lastName: string;
  patient: {
    _id: string;
    profileInfo: {
      firstName: string;
      lastName: string;
    };
  };
}

const LeaderboardLineGraph = ({ athleteList }: { athleteList: Athlete[] }) => {
  const [historicalData, setHistoricalData] = useState<any[]>([]);
  interface DateItem {
    date: string;
    [key: string]: any; // Allow any additional properties
  }

  const sortByDate = (arr: DateItem[], ascending = true): DateItem[] => {
    return arr.sort((a, b) => {
      const dateA = new Date(a.date).getTime();
      const dateB = new Date(b.date).getTime();

      // Check if dates are valid
      if (isNaN(dateA) || isNaN(dateB)) {
        throw new Error("Invalid date format found in array");
      }

      // Sort ascending or descending based on parameter
      return ascending ? dateA - dateB : dateB - dateA;
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      const athleteIds = athleteList.map((item: Athlete) => item._id);
      const response = await getAthleteAverages(athleteIds);
      const data = response.processedExamsGroupsByPatient;

      const parsedData = data.map((item: any, index: number) => {
        const athlete = athleteList.find(
          (athlete: Athlete) => athlete._id === item.patientId
        );
        let processedDates: string[] = [];
        const processedData = sortByDate(item.examGroups).map(
          (group: any, gIndex: number) => {
            const date = moment(group.date).format("YYYY-MM-DD");
            if (!processedDates.includes(date)) {
              processedDates.push(date);
            } else {
              return {
                x: null,
                y: null,
              };
            }
            return {
              x:
                group.examGroupId !== "undefined" &&
                group.examGroupId !== undefined
                  ? date
                  : null,
              y: group.average,
            };
          }
        );
        return {
          id: `${athlete?.patient.profileInfo.firstName} ${athlete?.patient.profileInfo.lastName}`,
          color: COLORS[index],
          data: processedData.filter(
            (item: any) => item.x !== null && item.y !== null
          ),
        };
      });
      console.log({ parsedData });
      setHistoricalData(parsedData.reverse());
    };
    fetchData();
  }, [athleteList]);
  return (
    <div style={{ height: "500px" }}>
      {historicalData.length && <LineGraph data={historicalData} />}
    </div>
  );
};

export default LeaderboardLineGraph;
